module.exports = __webpack_public_path__ + "static/img/newStock2.2ba45a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/newStock/newStock2.jpg
// module id = 14dz
// module chunks = 1